import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {ValueTypeDescriptor} from "#template/runtime-graph/descriptors"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const entriesToMapClassCache = new Map<ValueTypeDescriptor<any> | undefined, any>()

export function makeEntriesToMapClass<K, V>(valueType: TypeDescriptors.Desc<V>) {
    const existing = entriesToMapClassCache.get(valueType)
    if (existing) return existing as typeof EntriesToMap

    const descriptor = {
        input: TD.inlet(TD.Array(TD.Tuple<[K, V]>())),
        output: TD.outlet(TD.Map<K, V>(valueType)),
    }

    class EntriesToMap implements NodeClassImpl<typeof descriptor, typeof EntriesToMap> {
        static descriptor = descriptor
        static uniqueName = "EntriesToMap"
        input!: Inlet<[K, V][]>
        output!: Outlet<Map<K, V>>

        run() {
            if (this.input === NotReady) {
                this.output.emitIfChanged(NotReady)
                return
            }
            const map = new Map<K, V>()
            for (const [key, value] of this.input) {
                map.set(key, value)
            }
            this.output.emitIfChanged(map)
        }
    }

    entriesToMapClassCache.set(valueType, EntriesToMap)
    return EntriesToMap
}
